"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _InputLabel.default;
  }
});

var _InputLabel = _interopRequireDefault(require("./InputLabel"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/InputLabel/index.js
// module id = 138
// module chunks = 0